import { render, staticRenderFns } from "./SwaggerModulo.vue?vue&type=template&id=7e354f58&"
import script from "./SwaggerModulo.vue?vue&type=script&lang=ts&"
export * from "./SwaggerModulo.vue?vue&type=script&lang=ts&"
import style0 from "./SwaggerModulo.vue?vue&type=style&index=0&id=7e354f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports